import React, { useEffect, useState } from "react";
import { Mask } from "antd-mobile";
import "./../index.scss";
import icon_fx from "./../images/icon_fx.png";
import transverterFn from "i18nData";
export default function Share(props) {
  const { lang = "zh" } = props;
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Mask visible={visible} onMaskClick={() => setVisible(false)}>
        <div className="share_mask_box">点击右上角即可分享给好友哦</div>
        <div className="share_mask_btn" onClick={() => setVisible(false)}>
          我知道了
        </div>
      </Mask>
      <div className="share_box" onClick={() => setVisible(true)}>
        <img
          alt=""
          src={icon_fx}
          style={{ width: ".43rem", marginTop: ".24rem" }}
        />
        <p>{lang === "zh" ? "分享" : "Share"}</p>
      </div>
    </>
  );
}
